import { render, staticRenderFns } from "./nav-bar.vue?vue&type=template&id=1063f6ae&"
import script from "./nav-bar.vue?vue&type=script&lang=js&"
export * from "./nav-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports